module.exports = __webpack_public_path__ + "static/premium-classic@2x-b274afaf78e23b0b52d6a0c748a75cf6.png";